import {entityProperties} from "./EntityProperties";

export const SearchEntitiesAndContactsByLayerId = `
    query searchEntitiesAndContactsByLayerId ($search: String!, $layerIds: [Int]) {
        searchEntitiesByLayerId (search: $search, layerids: $layerIds) {
            nodes {
                ${entityProperties}
            }
        }
        searchContactsByLayerId (search: $search, layerids: $layerIds) {
            nodes {
                geoType
                entitycontactsByFullUid {
                    nodes {
                        entityByFullUid {
                            ${entityProperties}
                        }
                    }
                }
            }
        }
    }
`